// src/core/i18n/zh.js
/**
 * 中文翻译文件
 */
const zhTranslations = {
  // 通用
  common: {
    welcome: "欢迎来到MGX AI数字情感陪伴平台",
    loading: "加载中...",
    error: "发生错误",
    retry: "重试",
    save: "保存",
    cancel: "取消",
    confirm: "确认",
    delete: "删除",
    edit: "编辑",
    create: "创建",
    search: "搜索",
    more: "更多",
    back: "返回",
    submit: "提交",
    next: "下一步",
    previous: "上一步",
    finish: "完成",
    yes: "是",
    no: "否",
    success: "成功",
    failed: "失败",
    notFound: "未找到",
    unknown: "未知",
    all: "全部"
  },
  
  // 导航
  nav: {
    home: "首页",
    aiCompanion: "全息情感陪伴",
    virtualPet: "虚拟宠物",
    digitalHuman: "数字永生",
    vrExperience: "VR体验专区",
    store: "模拟商城",
    feedback: "用户反馈",
    investment: "投资招聘",
    profile: "个人中心",
    settings: "设置"
  },
  
  // 认证相关
  auth: {
    login: "登录",
    register: "注册",
    logout: "退出登录",
    email: "邮箱",
    password: "密码",
    confirmPassword: "确认密码",
    forgotPassword: "忘记密码？",
    resetPassword: "重置密码",
    name: "姓名",
    phone: "手机号",
    verificationCode: "验证码",
    sendVerificationCode: "发送验证码",
    loginWithEmail: "邮箱登录",
    loginWithPhone: "手机号登录",
    registerWithEmail: "邮箱注册",
    registerWithPhone: "手机号注册",
    alreadyHaveAccount: "已有账号？",
    dontHaveAccount: "没有账号？",
    loginSuccess: "登录成功",
    registerSuccess: "注册成功",
    logoutSuccess: "退出成功",
    passwordResetSuccess: "密码重置成功",
    passwordsDontMatch: "两次输入的密码不一致",
    invalidEmail: "邮箱格式不正确",
    invalidPhone: "手机号格式不正确",
    weakPassword: "密码太弱，请使用至少8位包含字母和数字的组合",
    membershipStatus: "会员状态",
    standardMember: "普通会员",
    premiumMember: "高级会员",
    upgradeMembership: "升级会员"
  },
  
  // 全息情感陪伴
  aiCompanion: {
    title: "全息情感陪伴",
    description: "与AI角色进行有温度的对话，建立情感连接",
    characters: "角色列表",
    createCharacter: "创建角色",
    characterName: "角色名称",
    personality: "性格特点",
    backstory: "背景故事",
    voiceType: "语音类型",
    chatHistory: "对话历史",
    clearChat: "清空对话",
    sendMessage: "发送消息",
    voiceChat: "语音聊天",
    roleplay: "角色扮演",
    emotionalSupport: "心理疏导",
    virtualDating: "虚拟恋爱",
    companionship: "日常陪伴",
    messageInput: "输入消息...",
    emotionAnalysis: "情感分析",
    memories: "记忆库",
    relationship: "关系等级",
    customizeAppearance: "自定义外观",
    publicCharacters: "公共角色",
    myCharacters: "我的角色",
    avatarSelection: "选择头像"
  },
  
  // 虚拟宠物
  virtualPet: {
    title: "虚拟宠物",
    description: "抚养和培养您的专属虚拟宠物",
    myPets: "我的宠物",
    createPet: "创建宠物",
    petName: "宠物名称",
    species: "宠物种类",
    feed: "喂食",
    play: "玩耍",
    train: "训练",
    sleep: "睡觉",
    clean: "清洁",
    health: "健康",
    happiness: "开心度",
    energy: "能量",
    intelligence: "智力",
    level: "等级",
    experience: "经验",
    skills: "技能",
    inventory: "物品",
    shop: "宠物商店",
    foodItems: "食物",
    toys: "玩具",
    accessories: "配饰",
    interactionHistory: "互动记录"
  },
  
  // 数字永生
  digitalHuman: {
    title: "数字永生",
    description: "创建和保存数字化的人格记忆",
    myDigitalHumans: "我的数字人",
    createDigitalHuman: "创建数字人",
    name: "姓名",
    uploadMedia: "上传媒体",
    trainMemory: "训练记忆",
    familyTree: "家族树",
    relationships: "人际关系",
    memories: "记忆",
    importantEvents: "重要事件",
    timeline: "时间线",
    personalityTraits: "个性特征",
    conversationStyle: "对话风格",
    voiceModel: "语音模型",
    recordVoice: "录制声音",
    memoriesDatabase: "记忆数据库",
    exportData: "导出数据",
    importData: "导入数据",
    privacySettings: "隐私设置",
    trainingStatus: "训练状态",
    chatWithDigitalHuman: "与数字人对话"
  },
  
  // VR体验
  vrExperience: {
    title: "VR体验专区",
    description: "沉浸式虚拟现实互动体验",
    enterVR: "进入VR模式",
    exitVR: "退出VR模式",
    environments: "环境选择",
    characters: "角色选择",
    interactions: "交互方式",
    vrDevices: "支持设备",
    vrTutorial: "VR教程",
    compatibility: "兼容性检查",
    performanceSettings: "性能设置",
    navigation: "导航控制",
    immersiveModes: "沉浸模式",
    virtualRoom: "虚拟房间",
    outdoorScenes: "户外场景",
    fantasyWorlds: "奇幻世界",
    historyScenes: "历史场景",
    deviceRequired: "需要VR设备",
    webVRExperience: "网页VR体验",
    fullVRExperience: "完整VR体验"
  },
  
  // 商城
  store: {
    title: "模拟商城",
    description: "购买各种数字商品和服务",
    products: "商品",
    cart: "购物车",
    orders: "订单",
    checkout: "结算",
    payment: "支付",
    totalAmount: "总金额",
    addToCart: "加入购物车",
    removeFromCart: "从购物车移除",
    continueShopping: "继续购物",
    emptyCart: "购物车为空",
    orderHistory: "订单历史",
    orderDate: "订单日期",
    orderStatus: "订单状态",
    productDetails: "商品详情",
    relatedProducts: "相关商品",
    categories: {
      all: "全部分类",
      avatar: "头像",
      accessory: "配饰",
      background: "背景",
      voice: "语音",
      feature: "功能"
    },
    filter: "筛选",
    sort: "排序",
    priceRange: "价格区间"
  },
  
  // 用户反馈
  feedback: {
    title: "用户反馈",
    description: "分享您的体验和建议",
    submitFeedback: "提交反馈",
    feedbackType: "反馈类型",
    subject: "主题",
    message: "留言",
    rating: "评分",
    bug: "问题报告",
    suggestion: "功能建议",
    complaint: "投诉",
    praise: "称赞",
    other: "其他",
    attachScreenshot: "附上截图",
    yourFeedback: "您的反馈",
    feedbackHistory: "反馈历史",
    responseFromTeam: "团队回复",
    feedbackSubmitted: "反馈已提交",
    thanksForFeedback: "感谢您的反馈",
    waitingForResponse: "等待回复"
  },
  
  // 投资招聘
  investment: {
    title: "投资招聘",
    description: "投资机会和加入团队",
    investmentOpportunities: "投资机会",
    careers: "招聘岗位",
    aboutUs: "关于我们",
    companyVision: "公司愿景",
    contactUs: "联系我们",
    investorRelations: "投资者关系",
    jobOpenings: "职位空缺",
    applyNow: "立即申请",
    requiredSkills: "所需技能",
    responsibilities: "职责",
    qualifications: "资格要求",
    location: "地点",
    remote: "远程",
    salary: "薪资",
    sendResume: "发送简历",
    meetTeam: "团队成员",
    fundingRounds: "融资轮次",
    partnerships: "合作伙伴"
  },
  
  // 设置
  settings: {
    title: "设置",
    account: "账户设置",
    profile: "个人资料",
    security: "安全设置",
    privacy: "隐私设置",
    notifications: "通知设置",
    language: "语言",
    theme: "主题",
    darkMode: "深色模式",
    lightMode: "浅色模式",
    autoTheme: "自动主题",
    dataUsage: "数据使用",
    syncSettings: "同步设置",
    deleteAccount: "删除账号",
    updateProfile: "更新个人资料",
    changePassword: "更改密码",
    linkedAccounts: "关联账号",
    twoFactorAuth: "两步验证",
    dataSharingOptions: "数据共享选项",
    pushNotifications: "推送通知",
    emailNotifications: "邮件通知",
    paymentMethods: "支付方式",
    billingHistory: "账单历史",
    autoRenewal: "自动续订"
  },
  
  // 错误信息
  errors: {
    general: "出错了，请稍后再试",
    network: "网络连接失败",
    unauthorized: "未授权，请登录",
    forbidden: "无权访问",
    notFound: "未找到请求的资源",
    serverError: "服务器错误",
    validation: "输入验证失败",
    timeout: "请求超时",
    loginRequired: "需要登录",
    expiredSession: "会话已过期，请重新登录",
    rateLimited: "请求过于频繁，请稍后再试"
  },
};

export default zhTranslations;